import React, { useState, useEffect, useMemo, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { capitalizeFirstLetters, formatAccount } from '../../features/ValueFormater';
import { useRowSelect, useTable } from 'react-table';
import Table from '../../components/Table';
import { setRequestData } from '../../features/transactionDetailsSlice';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox } from '../../components/Checkbox';
import { setActionPayload, setActionType } from '../../features/authorizationSlice';
import { ACTION_TYPES } from '../../app/actionTypes';
import { useOutletContext } from 'react-router-dom';
import { TYPE_IDS } from '../../app/typeIds';

const CashAdvancePendingApproval = () => {

    const { quickPayDetails, checkerAdvanceId } = useSelector(state => state.quickPay);

    const [onOpenQrAfterGenerate] = useOutletContext();

    const dispatch = useDispatch();
    const [setIsApproveButtonDisabled, setSetIsApproveButtonDisabled] = useState(false);

    const [cashAdvanceDetailsPayload, setCashAdvanceDetailsPayload] = useState([]);

    const detailsColumns = useMemo(() => [
        {
            Header: 'Employee',
            accessor: row => `${row.EmployeeFirstName} ${row.EmployeeLastName}`
        },
        {
            Header: 'test',
            accessor: 'test',
        },
        {
            Header: 'Phone Number',
            accessor: 'PhoneNumber',
            Cell: ({ value }) => {
                return <span>{value}</span>
            },
        },
        {
            Header: 'In Advance Payment',
            accessor: 'InAdvancePaymentAmount',
            Cell: ({ row, value }) => {
                return <span>{formatAccount(value, row.original.InAdvancePaymentCurrency)}</span>
            },
        },
        {
            Header: 'Start Date',
            accessor: 'StartDate'
        },
        {
            Header: "Status",
            accessor: "Status",
            Cell: ({ value }) => {
                if (value === "Correct" || value === "Checked") {
                    return <button style={{
                        color: "white",
                        fontFamily: "Poppins Medium ",
                        fontSize: "14px",
                        backgroundColor: "#199B2D",
                        borderRadius: "20px",
                        width: "120px",
                        padding: "5px 0"
                    }}>{capitalizeFirstLetters(value)}</button>;
                }

                return <span>{value}</span>
            }
        },
        {
            Header: "",
            accessor: "Reason"
        }
    ], [quickPayDetails]);

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, selectedFlatRows } =
    useTable({ columns: detailsColumns, data: quickPayDetails }, useRowSelect, (hooks) => {
        hooks.visibleColumns.push((columns) => {
            return [
                {
                    id: 'selection',
                    Header: ({getToggleAllRowsSelectedProps}) => (
                        <Checkbox {...getToggleAllRowsSelectedProps()} />
                    ),
                    Cell: ({row}) => (
                        row.original.IsPayrollReference || row.original.Method === "Quick Pay" ? null : (
                            <Checkbox {...row.getToggleRowSelectedProps()} />
                        )
                    )
                },
                ...columns,
            ]
    })});

    useEffect(() => {
        if(selectedFlatRows) {
            const isDisabled = selectedFlatRows.length === 0;
            const selectedRows = selectedFlatRows.map((row) => row.original);

            setSetIsApproveButtonDisabled(isDisabled);
            setCashAdvanceDetailsPayload([...selectedRows]);
        }
        else {
            setSetIsApproveButtonDisabled(true);
        }

    }, [selectedFlatRows]);

    const handleApprove = (e) => {
        e.preventDefault();
        const payload = {
            quickPayDetailsList: cashAdvanceDetailsPayload,
            status: "Approve",
            CheckerAdvanceID: checkerAdvanceId
        }

        dispatch(setActionType(ACTION_TYPES.APPROVE_QUICK_PAY_MOBILE));
        dispatch(setActionPayload(payload));
        onOpenQrAfterGenerate({
            typeId: TYPE_IDS.CONFIRM_QUICK_PAY,
            additionalData: {
              count: cashAdvanceDetailsPayload.length.toString()
            }
        });

    };

    const handleReject = (e) => {
        e.preventDefault();

        const payload = {
            quickPayDetailsList: cashAdvanceDetailsPayload,
            status: "Reject",
            CheckerAdvanceId: checkerAdvanceId
        }

        dispatch(setActionType(ACTION_TYPES.APPROVE_QUICK_PAY));
        dispatch(setActionPayload(payload));
        onOpenQrAfterGenerate({
            typeId: TYPE_IDS.CONFIRM_QUICK_PAY,
            additionalData: {
                count: cashAdvanceDetailsPayload.length.toString()
            }
        });

    };

    return (
        <div className="pending-approval-page">
            <div className="approval row">
                {quickPayDetails ?
                    <div className={"col-12"}>
                        <Table
                            headerGroups={headerGroups}
                            page={rows}
                            prepareRow={prepareRow}
                            getTableProps={getTableProps}
                            getTableBodyProps={getTableBodyProps}
                            setActiveRowIndex={(value) => dispatch(setRequestData({ field: "activeRowIndex", value }))}
                            setAmountDetails={(value) => dispatch(setRequestData({ field: "amountDetails", value }))}
                            setVisible={(value) => dispatch(setRequestData({ field: "visible", value }))}
                            removeRowListen={false}
                        />
                        <div className='cash-adv-action-buttons'>
                            <button 
                                disabled={setIsApproveButtonDisabled}
                                onClick={handleReject}
                                style={{
                                    color: "#D32127",
                                    fontFamily: "Poppins Medium ",
                                    fontSize: "14px",
                                    backgroundColor: "white",
                                    border: "1px solid #D32127",
                                    borderRadius: "5px",
                                    width: "200px",
                                    height: "50px",
                                    padding: "5px 0",
                                    margin: "0 30px",
                                    opacity: setIsApproveButtonDisabled ? 0.5 : 1
                                }}
                                title="Reject everything shown on the table"
                            >
                                Delete {`(${selectedFlatRows.length})`}
                            </button>
                            <button
                                disabled={setIsApproveButtonDisabled}
                                onClick={handleApprove}
                                style={{
                                    color: "white",
                                    fontFamily: "Poppins Medium ",
                                    fontSize: "14px",
                                    backgroundColor: "#226D96",
                                    borderRadius: "5px",
                                    width: "200px",
                                    height: "50px",
                                    padding: "5px 0",
                                    margin: "0 30px",
                                    opacity: setIsApproveButtonDisabled ? 0.5 : 1
                                }}
                                title="Approve the shown cash advance requests"
                            >
                                Approve {`(${selectedFlatRows.length})`}
                            </button>
                        </div>
                    </div> : <></>}
            </div>
        </div>
    );
};

export default CashAdvancePendingApproval;